import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-redirect-link',
  templateUrl: './redirect-link.component.html',
  styleUrls: []
})
export class RedirectLinkComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const target = this.route.snapshot.data['target'];
    if (target) {
      window.location.href = target;
    } else {
      console.error('Hedef URL belirtilmedi.');
    }
  }
}
